/**
* @Author: zachalam
* @Date:   2017-01-31T15:33:18-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-31T15:33:18-08:00
*/

/* globals google */
import moment from 'moment-timezone';
import { find } from 'lodash';
import UserConfig from './config/User';
import { GOOGLE_API_KEY } from './config/Master'


// as per API spec - use LAX time.
moment.tz.setDefault("America/Los_Angeles");


/* returns number of years since timestamp (ie: 36) */
export const tsYears = (timestamp) => {
  return moment().diff(timestamp, 'years');
}

/* returns human readable "since" timestamp (ie: 1 min ago) */
export const tsSince = (timestamp) => {
  if(timestamp === 0) return "N/A";
  else return moment(timestamp).fromNow();
}

export const tsDate = (timestamp, dtFormat='MMMM Do YYYY') => {
  return moment(timestamp).format(dtFormat);
}

/**
 * Return the difference of 2 days based on the diff choice.
 * @param {Int} startTs beginning Timestamp
 * @param {Int} endTs Ending Timestamp
 * @param {String} diff Magnitude that is requested. ('days', 'years')
 * @param {Boolean} floatingPoint Whether it should return a rounded Integer or Floating Point Number
 */
export const tsDiff = (startTs, endTs, diff='days', floatingPoint=false) => {
  const Start = moment(startTs);
  const End = moment(endTs);

  return End.diff(Start, diff, floatingPoint);
}

export const tsDiffUntilNow = (date, diff='days', floatingPoint=false) => {
  const START = moment(date);
  const NOW = moment();

  return NOW.diff(START, diff, floatingPoint);
}

export const tsNow = () => {
  return moment().utc().valueOf();
}

export const extractLocationData = (location) => {
  // extracts google map data for data expected by API.
  // city => locality
  // region => administrative_area_level_1
  // country => country

  let city, region, country, latitude, longitude;

  if(location.geometry) {
    latitude = location.geometry.location.lat();
    longitude = location.geometry.location.lng();
  }

  if(location.address_components) {
    let cityObj = find(location.address_components, {types: ['locality']});
    let regionObj = find(location.address_components, {types: ['administrative_area_level_1']})
      || find(location.address_components, {types: ['administrative_area_level_2']});
    let countryObj = find(location.address_components, {types: ['country']});
    if(cityObj)
      city = cityObj.long_name;
    if(regionObj)
      region = regionObj.long_name
    if(countryObj)
      country = countryObj.long_name
  };

  return {
    city, region, country, latitude, longitude
  };
}

export const extractDepartureLocationData = (location) => {
  // returns locData object with newly assigned "departing_from" keys.
  let locData = extractLocationData(location);
  return {
    departing_from_city: locData.city,
    departing_from_region: locData.region,
    departing_form_country: locData.country,
    departing_from_latitude: locData.latitude,
    departing_from_longitude: locData.longitude
  }
}


export const cleanObject = (myObj) => {
  if( myObj && myObj !== "null" && myObj !== "undefined" ){
    Object.keys(myObj).forEach((key) => (myObj[key] === '') && delete myObj[key]);
  }
  return myObj;
}

export const stripHeightMaxes = (dataObj) => {
  if((dataObj.height_min === UserConfig.minimumHeight) &&
      (dataObj.height_max === UserConfig.maximumHeight)) {
        // delete these items from dataObj.
        delete dataObj.height_min;
        delete dataObj.height_max;
      }

    return dataObj;
}

export const metricConv = (n) => {
  var realFeet = ((n*0.393700) / 12);
  var feet = Math.floor(realFeet);
  var inches = Math.round((realFeet - feet) * 12);
  return feet + "'" + inches + '"';
}

/** Get geocode results from a PlaceId */
export const geocodeByPlaceId = (placeId) => {
  const geocoder = new google.maps.Geocoder();
  const OK = google.maps.GeocoderStatus.OK;

  return new Promise((resolve, reject) => {
    geocoder.geocode({ placeId }, (results, status) => {

      if(status !== OK) {
        reject(status);
      }

      resolve(results);
    });
  });
};

export const geocodeByAddress = (city, region, country ) => {
  const geocoder = new google.maps.Geocoder();
  const OK = google.maps.GeocoderStatus.OK;

  const address = `${city}, ${region}, ${country}`;

  return new Promise((resolve, reject) => {
    geocoder.geocode( {address}, (results, status) => {
      if(status !== OK) {
        reject(status);
      }

      resolve(results);
    });
  });
}

export const createGoogleMap = (lat, lng, opts) => {
  if(!lat || !lng) {
    return Error('Need to pass in a Lat and Lng to correctly get a map');
  };

  const DEFAULT_OPTIONS = {
    horizontal: 350,
    vertical: 400,
    scale: 1,
    zoom: 10,
    markerColor: 'red'
  };

  const options = Object.assign({}, DEFAULT_OPTIONS, opts);

  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=${options.scale}&markers=color:${options.markerColor}|${lat},${lng}&zoom=${options.zoom}&size=${options.horizontal}x${options.vertical}&key=${GOOGLE_API_KEY}`;
}



// WEBPACK FOOTER //
// ./src/common.js